import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/shared/ui/dialog';
import { PhotoForm } from './forms';
import { ViewPosition } from '../types/types';

interface FABActionDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  photoId?: number;
  viewPosition?: ViewPosition | null;
  onSuccess?: () => void;
  onHotspotCreated?: () => Promise<void>;
  hotspotId?: number; // For adding to existing hotspot
}

const FABActionDialog = ({
  open,
  setOpen,
  photoId,
  viewPosition,
  onSuccess,
  onHotspotCreated,
  hotspotId,
}: FABActionDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Photo Overlays</DialogTitle>
          <DialogDescription>
            {hotspotId
              ? 'Add one or more photos to this hotspot'
              : 'Add one or more photo overlays to mark this location in the 360° view'}
          </DialogDescription>
        </DialogHeader>
        {photoId && viewPosition ? (
          <PhotoForm
            photoId={photoId}
            viewPosition={viewPosition}
            hotspotId={hotspotId}
            onSuccess={async () => {
              await onHotspotCreated?.();
              onSuccess?.();
            }}
            onCancel={() => setOpen(false)}
          />
        ) : (
          <div className="text-center text-muted-foreground">Please open a 360° photo to add photos</div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FABActionDialog;
